// // styles.js

// export const boardContainer = {
//   display: "flex",
//   flexWrap: "wrap",
//   gap: "20px",
//   padding: "20px",
// };

// export const columnStyle = {
//   flex: 1,
//   minWidth: "250px",
//   background: "#f4f5f7",
//   padding: "15px",
//   borderRadius: "8px",
//   minHeight: "400px",
// };

// export const columnTitle = {
//   paddingBottom: "10px",
//   color: "#667085",
//   fontFamily: "Inter",
//   fontSize: "12px",
//   fontStyle: "normal",
//   fontWeight: 700,
//   lineHeight: "normal",
//   marginBottom: "15px",
// };

// export const cardStyle = {
//   position: "relative",
//   background: "white",
//   padding: "15px",
//   marginBottom: "15px",
//   borderRadius: "6px",
//   boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
//   display: "flex",
//   flexDirection: "column",
// };

// export const descriptionText = {
//   opacity: 0.6,
//   alignSelf: "stretch",
//   color: "#1D2939",
//   fontFamily: "Inter",
//   fontSize: "14px",
//   fontStyle: "normal",
//   fontWeight: 500,
//   lineHeight: "150%",
// };

// export const linkText = {
//   color: "#2F80ED",
//   fontSize: "13px",
// };

// export const subtasksWrapper = {
//   marginTop: "10px",
// };

// export const subtasksList = {
//   paddingLeft: "0px",
//   marginTop: "6px",
//   listStyle: "none",
// };

// export const subtaskRow = {
//   display: "flex",
//   alignItems: "center",
//   marginBottom: "8px",
//   gap: "8px",
// };

// export const checkboxContainer = {
//   display: "flex",
//   alignItems: "center",
//   cursor: "pointer",
// };

// export const checkboxBase = (completed) => ({
//   appearance: "none",
//   width: "16px",
//   height: "16px",
//   borderRadius: "4px",
//   border: completed ? "none" : "1.5px solid #98A2B3",
//   backgroundColor: completed ? "#12B066" : "white",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   position: "relative",
// });

// export const imageStyle = {
//   width: "100%",
//   marginTop: "10px",
//   borderRadius: "4px",
// };

// export const tagsContainer = {
//   display: "flex",
//   gap: "8px",
//   marginTop: "auto",
//   paddingTop: "12px",
//   flexWrap: "wrap",
// };

// export const tagStyles = {
//   Design: { background: "#F2F4F7", color: "#344054" },
//   Backend: { background: "#D1FADF", color: "#12B066" },
//   Frontend: { background: "rgba(123, 97, 255, 0.20)", color: "#9747FF" },
// };

// export const head3 = {
//   alignSelf: "stretch",
//   color: "#1D2939",
//   fontFamily: "Inter",
//   fontSize: "18px",
//   fontStyle: "normal",
//   fontWeight: 700,
//   lineHeight: "150%",
// };

import { createStyles } from "@mantine/core";

export const useStyles = createStyles(() => ({
  boardContainer: {
    display: "flex",
    overflowX: "auto",
    gap: 20,
    position: "relative",
    width: "100%",
  },

  column: {
    flex: 1,
    minWidth: 272,
    background: "#f4f5f7",
    borderRadius: 8,
    minHeight: 600,
  },

  // columnTitle: {
  //   padding: "0px 0px 10px 0px",
  //   margin: 0,
  //   color: "#667085",
  //   fontFamily: "Inter",
  //   fontSize: 12,
  //   fontWeight: 700,
  //   textTransform: "capitalize",
  // },

  columnTitle: {
    padding: "10px 12px",
    margin: 0,
    color: "#667085",
    fontFamily: "Inter",
    fontSize: 12,
    fontWeight: 700,
    textTransform: "capitalize",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",

    "& .deleteStatusBtn": {
      visibility: "hidden",
      opacity: 0,
      transition: "opacity 0.15s ease",
      position: "absolute",
      right: 10,
    },
    "&:hover .deleteStatusBtn": {
      visibility: "visible",
      opacity: 1,
    },
  },


  columnFooter: {
    flexDirection: "column",
    alignItems: "center",
    gap: 8,
    padding: "0px 12px 12px",
    "& .shownCount": {
      fontSize: 12,
      fontFamily: "Inter",
      color: "#667085",
    },
  },

  emptyDrop: {
    height: 60,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#999",
    fontSize: 14,
    border: "2px dashed #e0e0e0",
    borderRadius: 6,
    background: "#fafbfc",
  },

  // task card styling *******

  taskCard: {
    position: "relative",
    background: "#FFF",
    padding: 16,
    marginBottom: 16,
    borderRadius: 8,
    boxShadow: "0 0.5px 2px 0 rgba(16, 24, 40, 0.30)",
    display: "flex",
    flexDirection: "column",
    gap: 10,
  },

  taskCardTitle: {
    color: "#1D2939",
    fontFamily: "Inter",
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 500,
    margin: 0,
  },

  taskCardDescription: {
    opacity: 0.6,
    color: "#1D2939",
    fontFamily: "Inter",
    fontSize: 12,
    cursor: "pointer",
    fontWeight: 400,
    margin: "4px 0px 0px 0px",
  },

  assignedTo: {
    alignItems: "center",
    gap: 8,
    "& .label": {
      fontSize: 13,
      fontWeight: 500,
      fontFamily: "Inter",
      whiteSpace: "nowrap",
      color: "#475467",
      padding: "4px 8px",
      borderRadius: 6,
      backgroundColor: "#F2F4F7",
    },
    "& .assignedName": {
      fontSize: 13,
      fontWeight: 600,
      fontFamily: "Inter",
      color: "#475467",
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
    },
  },

  taskCardAttachedItems: {
    alignItems: "center",
    "& .fileName": {
      fontSize: 12,
      fontWeight: 500,
      fontFamily: "Inter",
      color: "#4186F4",
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
      cursor: "pointer",
      "&:hover": {
        textDecoration: "underline",
      },
    },
    "& a": {
      textDecoration: "none",
      color: "inherit",
    },
    "& svg": {
      color: "#ACACAC",
      fontSize: 15,
      marginRight: 4,
    },
  },

  popoverDropdown: {
    padding: 0,
  },

  staffItem: {
    alignItems: "center",
    gap: 10,
    padding: "10px",
    cursor: "pointer",
    "& .staffName": {
      fontSize: 14,
      fontWeight: 500,
      fontFamily: "Inter",
      color: "#475467",
      margin: 0,
    },
    "&:hover": {
      backgroundColor: "#F2F4F7",
    },
  },
  assignedStaffItem: {
    backgroundColor: "rgba(65, 134, 244, 0.2)",
    cursor: "default",
    "&:hover": {
      backgroundColor: "rgba(65, 134, 244, 0.2)",
    },
  },
  addBtnAbsoluteBox: {
    position: "sticky",
    right: 0,
    top: 0,
    backgroundColor: "#f4f5f7",
    paddingLeft: 8,
  },
}));
